import React from 'react';

import PropTypes from 'prop-types';

import { Typography } from 'wanderu-components';

import styles from './HotelsCard.scss';

const propTypes = {
    description: PropTypes.node,
    title: PropTypes.string,
};

const defaultProps = {
    description: '',
    title: '',
};

const HotelsCard = (props) => {
    const {
        title,
        description,
    } = props;
    return (
        <>
            <div className={styles.cardBox}>
                <div className={styles.cardLayout}>
                    <Typography variant="h6">{title}</Typography>
                    <Typography variant="body2" component="span">{description}</Typography>
                </div>
            </div>
        </>
    );
};

HotelsCard.propTypes = propTypes;
HotelsCard.defaultProps = defaultProps;

export default HotelsCard;
